import React, { Fragment } from "react";
import Helmet from "react-helmet";
import cn from "classnames";
import "swiper/dist/css/swiper.min.css";
import "./index.styl";
import ForgotPassword from "../components/Auth/ForgotPassword";

const Page = () => (
  <Fragment>
    <Helmet
      title="Reset Password"
      // meta={[{ name: 'description', content: '' }]}
    />
<header
        className={cn("c-header", "c-header--full", "t-context--dark", "bg")}
      >
    <ForgotPassword name="forgotPassword" />
    </header>
  </Fragment>
);

export default Page;



// WEBPACK FOOTER //
// ./src/pages/forgotPassword.js